import { useMutation } from '@tanstack/react-query';
import { updateUserSettings } from 'shared/services/backend-api';
import { UserSettings } from 'shared/types/user-settings';

export const useUpdateUserSettingsMutation = () =>
  useMutation({
    mutationFn: async (settings: Partial<UserSettings>) =>
      updateUserSettings(settings),
  });
